module.exports = __webpack_public_path__ + "img/attention.e6174d92.svg";